import { useNavigate } from 'react-router';
import { useBusinessFunctionsMetrics } from '../../hooks/useBusinessFunctionsMetrics';
import { MetricCard } from '../MetricCard';

type BusinessFunctionsWidgetProps = {
  locationUuid: string;
};

export const BusinessFunctionsWidget = ({
  locationUuid,
}: BusinessFunctionsWidgetProps) => {
  const navigate = useNavigate();
  const { data: businessFunctionsData, loading: businessFunctionsLoading } =
    useBusinessFunctionsMetrics(locationUuid);

  const handleViewClick = () => {
    const basePath = '/cyber-hub/business-functions-report';
    const url = locationUuid
      ? `${basePath}?location=${locationUuid}`
      : basePath;
    navigate(url);
  };

  return (
    <MetricCard
      title="Business Functions"
      tooltipText="Total Business Functions and their tagged IT Applications."
      topMetric={{
        value: businessFunctionsData?.functionsCount ?? 0,
        description: locationUuid
          ? 'Location Business Functions'
          : 'Enterprise Level Business Functions',
      }}
      bottomMetric={{
        value: businessFunctionsData?.uniqueApplicationsCount ?? 0,
        description: 'Unique Applications Tagged to them',
      }}
      onViewClick={handleViewClick}
      isLoading={businessFunctionsLoading}
    />
  );
};
